import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

onDocumentReady(
  function dispatchPageViewEvent() {
    // Pages prerendered by the speculation rules in layout/theme.liquid run their scripts before
    // the visitor opens them (and may never be opened), so only count the view once it is shown.
    if (/** @type {Document & { prerendering?: boolean }} */ (document).prerendering) {
      document.addEventListener('prerenderingchange', dispatchPageViewEvent, { once: true });
      return;
    }

    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);
